/*
Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
  distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
  prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
  content, please contact the author for proper authorization and agreement.
  */
import clsx from 'clsx'

interface CountryFlagProps {
    countryCode?: string
    style?: 'normal' | 'decorated'
    className?: string
}

const CountryFlag = (props: CountryFlagProps) => {
    const flags = import.meta.glob('/src/components/CountryIcons/3x2/*.svg', {
        eager: true,
        query: 'url',
    }) as Record<string, { default: string }>

    const code = props.countryCode?.toUpperCase()
    const key = code
        ? `/src/components/CountryIcons/3x2/${code}.svg`
        : undefined

    const countryFlag = key ? flags[key]?.default : undefined

    return (
        <div
            className={clsx(
                'CountryFlag overflow-hidden',
                props.style === 'decorated'
                    ? 'decorated min-w-[38px] md:min-w-[45px] w-full min-h-[32px] md:min-h-[40px] h-full flex items-center justify-center rounded-tl-[5px] rounded-bl-[5px]'
                    : [
                          !props.className?.includes('w-') && 'w-[45px]',
                          !props.className?.includes('h-') &&
                              'min-h-[31px] h-[31px]',
                          'not-decorated border border-arbo-borderGray',
                      ],
                props.className
            )}
        >
            {countryFlag && (
                <img
                    className={clsx(
                        'w-full h-full object-cover',
                        props.style === 'decorated' &&
                            'rounded-tl-[4px] rounded-bl-[4px]'
                    )}
                    alt={`${props.countryCode} flag`}
                    src={countryFlag}
                />
            )}
        </div>
    )
}

export default CountryFlag
